// extracted by mini-css-extract-plugin
module.exports = {"plans":"styles_plans__8zMkL","plan":"styles_plan__U9H96","footer":"styles_footer__XzdeY"};